import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn as Column, GridFilterChangeEvent, GridPageChangeEvent } from '@progress/kendo-react-grid';
import { filterBy } from '@progress/kendo-data-query';
import { userList, updateUserListFilter, updateUserListPage, shareLinkByEmail } from 'src/actions/action.user';
import editUserButton from './EditUserButton'
import { EditUserWrapper } from 'src/styles/edituser';
import { Button, Typography, Grid as BootstrapGrid, Dialog, IconButton, DialogContent, DialogActions, FormControl, InputLabel, Input } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ApplicationMain } from 'src/styles/common';
import ActiveInactiveUserButton from './ActiveInactiveUserButton';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { Grid as GridDiv } from '@material-ui/core';

class UserListComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOpenInviteLinkDialog: false,
            toMailId: '',
            ccMailId: '',
            maxWidth: 'sm',
            inValidToEmailIds: [],
            inValidCcEmailIds: []
        }
    }

    componentDidMount() {
        this.props.updateUserListPage({
            skip: 0,
            take: 10
        });

        this.props.userList()
    }

    updateUserListFilter = (e: GridFilterChangeEvent) => {
        this.props.updateUserListFilter(e.filter);
        this.props.updateUserListPage({ skip: 0, take: 10 });
    }

    updateUserListPage = (event: GridPageChangeEvent) => {
        this.props.updateUserListPage(event.page);
    }

    // handle invite link button click event to open dialog box
    handleInviteLinkButtonClick = () => {
        this.setState({
            isOpenInviteLinkDialog: true
        })
    }

    // close invite dialog
    handleClose = () => {
        this.setState({
            isOpenInviteLinkDialog: false
        })
    }

    // validate email ids and send invite
    handleSendInvite = () => {
        const inValidToEmailIds = this.validateEmails(this.state.toMailId)
        if (this.state.toMailId !== '' && inValidToEmailIds.length > 0) {
            this.setState({ inValidToEmailIds })
            return;
        }

        const inValidCcEmailIds = this.validateEmails(this.state.ccMailId)
        if (this.state.ccMailId !== '' && inValidCcEmailIds.length > 0) {
            this.setState({ inValidCcEmailIds })
            return;
        }

        const data = {
            to: this.state.toMailId,
            cc: this.state.ccMailId
        }

        this.props.shareLinkByEmail(data)
        this.setState({
            isOpenInviteLinkDialog: false,
            inValidToEmailIds: [],
            inValidCcEmailIds: [],
            toMailId: '',
            ccMailId: ''
        })
    }

    // handle change event of input field of to and cc field
    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value,
            inValidToEmailIds: [],
            inValidCcEmailIds: [],
        })
    }

    // handle allow user to add multiple email 
    handleAllowMultipleEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.charCode === 32) {
            event.preventDefault();
        }
    }

    // validate email ids
    validateEmails = (emailIds: string) => {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        const resultedEmailIds = emailIds.replace(/\s/g, "").split(/,|;/);
        const invalidEmailIds: string[] = []
        resultedEmailIds.forEach((emailId: string) => {
            if (!regex.test(emailId)) {
                invalidEmailIds.push(emailId);
            }
        })

        return invalidEmailIds
    }

    render() {
        return (
            <ApplicationMain>
                <EditUserWrapper>
                    <div className="pageContainer">
                        <div className="pageHeading">
                            <BootstrapGrid container={true} spacing={0} >
                                <BootstrapGrid item={true} xs={6}>
                                    <div className="pageHeadingTitle">
                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                            Users
                                    </Typography>
                                    </div>
                                </BootstrapGrid>
                                <BootstrapGrid item={true} xs={6}>
                                    <div className="text-right">
                                        {
                                            (this.props.userId === 1 || this.props.userId === 2) &&
                                            < Button type="button" onClick={this.handleInviteLinkButtonClick} className="btn-blue" variant="outlined" size="medium">
                                                Invite Users
                                            </Button>
                                        }
                                        <Button type="button" className="btn-blue" variant="outlined" size="medium">
                                            <Link to={{ pathname: `/pendinguser` }}>Pending Requests</Link>
                                        </Button>
                                    </div>
                                </BootstrapGrid>
                            </BootstrapGrid>
                        </div>
                        <div className="pageContent">
                            <div className="editUserScreen">
                                {/* <Button><Link to={{ pathname: `/pendinguser` }}>Pending User</Link></Button> */}
                                <div className="kendoWrapper">
                                    <Grid
                                        data={filterBy(this.props.users, this.props.filter).slice(this.props.skip, this.props.take + this.props.skip)}
                                        filterable={true}
                                        filter={this.props.filter}
                                        onFilterChange={this.updateUserListFilter}
                                        skip={this.props.skip}
                                        take={this.props.take}
                                        total={filterBy(this.props.users, this.props.filter).length}
                                        pageable={true}
                                        onPageChange={this.updateUserListPage}
                                    >
                                        <Column field="" title="Status" filterable={false} cell={ActiveInactiveUserButton} />
                                        <Column field="firstName" title="First Name" filterable={true} />
                                        <Column field="lastName" title="Last Name" filterable={true} />
                                        <Column field="email" title="Email" filterable={true} />
                                        <Column field="roleText" title="Role" filterable={true} />
                                        <Column field="activeCountryName" title="Country" filterable={true} />
                                        <Column field="organization" title="Organization" filterable={true} />
                                        <Column field="isActive" filterable={false} title="Actions" cell={editUserButton} />
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.isOpenInviteLinkDialog &&
                        <GridDiv container={true} direction="row" justify="flex-end" alignItems="center">
                            <GridDiv item={true}>
                                <Dialog
                                    id="emailDialog"
                                    fullWidth={true}
                                    hideBackdrop={true}
                                    maxWidth={this.state.maxWidth}
                                    open={this.state.isOpenInviteLinkDialog}
                                    aria-labelledby="max-width-dialog-title"
                                    className="applicationDialog"
                                >
                                    <div className="dialogWrapper">
                                        <div className="dialogHead">
                                            <DialogTitle id="max-width-dialog-title" className="dialogTitle">Share link
                                            <IconButton aria-label="Close" className="closeButton text-right" onClick={this.handleClose}>
                                                    <CloseIcon />
                                                </IconButton>
                                                <hr className="HZDivider" />
                                                <span className="hint-text">Please enter an e-mail ID of users with whom you would like to share an invite. Multiple e-mail ID's must be comma separated.</span>
                                            </DialogTitle>
                                        </div>
                                        <div className="dialogContent">
                                            <DialogContent>
                                                <div id="emailDialogBody" className="dialogBox">
                                                    <GridDiv container={true} spacing={24}>
                                                        <GridDiv item={true} xs={12}>
                                                            <div>
                                                                <FormControl margin="normal" required={true} fullWidth={true}>
                                                                    <InputLabel htmlFor="toMailId">To: </InputLabel>
                                                                    <Input id="toMailId"
                                                                        name="toMailId"
                                                                        value={this.state.toMailId}
                                                                        placeholder="Enter E-mail IDs"
                                                                        onChange={this.handleChange}
                                                                        onKeyPress={this.handleAllowMultipleEmail}
                                                                        fullWidth={true}
                                                                    />
                                                                    {this.state.inValidToEmailIds.length > 0 && <span className="errorMessage">Invalid Email Ids {Array.isArray(this.state.inValidToEmailIds) ? this.state.inValidToEmailIds.join(', ') : this.state.inValidToEmailIds} </span>}
                                                                </FormControl >
                                                            </div>
                                                            <div>
                                                                <FormControl margin="normal" fullWidth={true}>
                                                                    <InputLabel htmlFor="ccMailId">CC: </InputLabel>
                                                                    <Input id="ccMailId"
                                                                        name="ccMailId"
                                                                        value={this.state.ccMailId}
                                                                        placeholder="Enter E-mail IDs"
                                                                        onChange={this.handleChange}
                                                                        onKeyPress={this.handleAllowMultipleEmail}
                                                                        fullWidth={true}
                                                                    />
                                                                    {this.state.inValidCcEmailIds.length > 0 && <span className="errorMessage">Invalid Email Ids {Array.isArray(this.state.inValidCcEmailIds) ? this.state.inValidCcEmailIds.join(', ') : this.state.inValidCcEmailIds} </span>}
                                                                </FormControl >
                                                            </div>
                                                        </GridDiv>
                                                    </GridDiv>
                                                </div>
                                            </DialogContent>
                                        </div>
                                        <div className="dialogAction">
                                            <DialogActions>
                                                <Button color="primary" disabled={this.state.toMailId.length > 0 ? false : true} onClick={this.handleSendInvite} className={this.state.toMailId.length > 0 ? 'btn-blue-primary' : ''}>
                                                    Send &nbsp; >
                                            </Button>
                                            </DialogActions>
                                        </div>
                                    </div>
                                </Dialog>
                            </GridDiv>
                        </GridDiv>
                    }
                </EditUserWrapper>
            </ApplicationMain>

        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        users: state.user.users,
        filter: state.user.filter,
        skip: state.user.page.skip,
        take: state.user.page.take,
        isSharedLink: state.user.isSharedLink
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        userList: () => dispatch(userList()),
        updateUserListFilter: (data: any) => dispatch(updateUserListFilter(data)),
        updateUserListPage: (data: any) => dispatch(updateUserListPage(data)),
        shareLinkByEmail: (data: any) => dispatch(shareLinkByEmail(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserListComponent);


// WEBPACK FOOTER //
// ./src/components/users/UserListComponent.tsx